// extracted by mini-css-extract-plugin
export default {"label":"styles_label__wiQ5X","error":"styles_error__r-OKa","tip":"styles_tip__GUzQX","button":"styles_button__U-HlE"};